/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView,AdvanceFormNew} from '../../components';
import { openNotice } from 'Utils';
import { getStockList, setProductUp, setProductDown, getProductCategory,getSubStoreList } from '../../service/product';
import {Store, Actions} from './store';
class AccountStatement extends Reflux.Component {
	constructor(props) {
		super(props);
		this.store = Reflux.initStore(Store); //创建一个Store实例
		this.state = {
			opts: ['对账单明细报表'],
			key: 0,
			filterBoxVisible: false,
			selectedRowKeys: [],
			rows: [],
			total: 1,
			searchObj: {
				name: '',
				category: [],
				active: '',
				s: 10,
				p: 1,
				startCreatedDate: '',
				endCreatedDate: '',
			},
			objType_type: [],
			// objType_type2: [],
			// categoryData: [],
			button_limits_end: {}
		};
		this.pageChange = this.pageChange.bind(this);
		this.changeHandle = this.changeHandle.bind(this);
		this.visibleChange = this.visibleChange.bind(this);
		this.setFilterParam = this.setFilterParam.bind(this);
		this.advanceReset = this.advanceReset.bind(this);
		this.advanceSubmit = this.advanceSubmit.bind(this);
		this.routeLeaveHook = this.routeLeaveHook.bind(this);
	}

	onSelectChange = (selectedRowKeys) => {
		this.setState({selectedRowKeys});
	}

	goView(url) {
		hashHistory.push(url);
	}

	goAdd() {
		alert('导入产品');
	}
	goChange(){
		this.setState({saveVisible: !this.state.saveVisible});
	}
	goDelete() {
		alert('正在删除');
	}
	changeHandle({item, key, keyPath}) {
		this.setState({key});
	}

	visibleChange() {
		this.setState({filterBoxVisible: !this.state.filterBoxVisible});
	}

	advanceReset() {
		let self = this;
		self.setState({
			filterBoxVisible: false,
			searchObj: {
				...this.state.searchObj,
				name: '',
				category: [],
				active: '',
				startCreatedDate: '',
				endCreatedDate: '',
			}
		}, function () {
			self.initData();
		});
	};

	advanceSubmit(form) {
		/* 筛选确认 */
		let self = this;
		this.setState({
			filterBoxVisible: false,
			searchObj: {
				...this.state.searchObj,
				p: 1
			}
		}, function () {
			self.initData();
		});
	};

	setFilterParam(name, value) {
		if (name === 'date') {
			this.setState({ searchObj: { ...this.state.searchObj, startCreatedDate: value.from, endCreatedDate: value.end } })
		} else {
			this.setState({ searchObj: { ...this.state.searchObj, [name]: value } })
		}
	};

	pageChange(page, pageSize) {
		/* 翻页 刷新 */
		let self = this;
		this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, function () {
			self.initData();
		});
	}

	updateProductStatusFn (key) {
		/* 产品上下架 */
		if (this.state.selectedRowKeys.length === 0) {
			openNotice('warning', '请选择产品');
			return;
		}
		let params = {
			'ids': this.state.selectedRowKeys
		};
		let self = this;
		if (key == 'up') {
			setProductUp(params).then(function (result) {
				if (result && result.code == 200) {
					openNotice('success', '上架操作成功', '');
					self.initData();
				} else {
					openNotice('error', '上架操作失败', (result && result.message) ? result.message : '');
				}
			});
		} else {
			setProductDown(params).then(function (result) {
				if (result && result.code == 200) {
					openNotice('success', '下架操作成功', '');
					self.initData();
				} else {
					openNotice('error', '下架操作失败', (result && result.message) ? result.message : '');
				}
			});
		}
	}

	initData () {
		let self = this;
		let searchObj = self.state.searchObj;
		searchObj.categoryId = searchObj.category.length > 0 ? searchObj.category[searchObj.category.length - 1] : '';
		getStockList(searchObj).then(function (result) {
			if (result && result.code == 200) {
				self.setState({
					'rows': result.data || [],
					'total': result.total
				});
			} else {
				openNotice('error', '数据获取失败', '');
			}
		});
	}

	//离开当前路由时，更新store
	routeLeaveHook(nextLocation) {
		let path = nextLocation.pathname.split('/');
		if(path[1] === 'product'){ //当下一个路由是详情页时，将useStore的值设为true
			Actions.useStoreChange(true);
			Actions.paramChange(this.state.searchObj);
		}else{
			Actions.useStoreChange(false);
			Actions.paramChange({});
		}
	}

	componentWillMount () {
		let self = this;
		const data = this.store.state;
		if(data.useStore) { //根据useStore的值判断是否使用store中的数据
			this.setState({
				...this.state,
				searchObj: {
					...this.state.searchObj,
					...data.params
				},
				key: data.params.buyerStatus || 0
			});
		}
		// getProductCategory().then(function (categoryResult) {
		// 	/* 产品分类 */
		// 	if (!categoryResult || categoryResult.code != 200) {
		// 		openNotice('error', '产品分类数据获取失败，请重试', '');
		// 		return;
		// 	}
		// 	self.setState({
		// 		categoryData: categoryResult.data || []
		// 	});
		// });
		// getSubStoreList().then(res => { //物料类别
		//     if(res.status){
		//         let arr = [
		//             {
		//                 text: '全部',
		//                 value: ''
		//             }
		//         ];
		//         res.data.forEach(x => {
		//             arr.push({
		//                 text: x.subStoreName,
		//                 value: x.id
		//             })
		//         });
		// 	self.setState({objType_type: arr})
		//     }
		// });
		// materialScreening2().then(res => { //物料类别
		// 	if(res.status){
		// 	    let arr = [
		// 	        {
		// 	            text: '全部',
		// 	            value: ''
		// 	        }
		// 	    ];
		// 	    res.data.forEach(x => {
		// 	        arr.push({
		// 	            text: x.subStoreName,
		// 	            value: x.id
		// 	        })
		// 	    });
		// 	    let timer = window.setInterval(function(){
		// 	        if(self.mounted){
		// 	            window.clearInterval(timer);
		// 	            self.setState({objType_type2: arr})
		// 	        }
		// 	    }, 0);
		// 	}
		// });
	}

	componentDidMount () {
		this.initData();
		//设置离开当前路由时的钩子函数
		this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
		this.setState({
			button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
		});
	}

	render() {
		const {opts, key, rows, total, searchObj, selectedRowKeys,objType_type,button_limits_end} = this.state;
		const filterBoxProps = {
			fileds: [
				{
					name: 'name4',//startCreatedDate, endCreatedDate
					label: '日期',
					options: [
							{ text: '从' },
							{ text: '至' },
						],
					type: 'dateComp',
					defaultValue: {
						from: searchObj.createTimeStart || '',
						end: searchObj.createTimeEnd || ''
					}
				},{
					name: 'materialNumber',
					label: '购货单位',
					text: '请输入关键字',
					type: 'default',
					defaultValue: searchObj.materialNumber
				}
			],
			handle: this.advanceSubmit,
			reset: this.advanceReset,
			fieldHandle: this.setFilterParam
		};
		const tableViewProps = {
			loading: false,//更新表格数据中
			rowKey: 'id',
			pageParam: {
				total: total,
				current: searchObj.p,//当前页码
				pageSize: searchObj.s,//当前分页数
				onChange: this.pageChange
			},
			columns: [
				{
					title: '对账单编号',
					dataIndex: 'materialNumber',
					width:150,
				}, {
					title: '片区',
					dataIndex: 'materialText',
					width:200
				}, {
					title: '购货单位',
					dataIndex: 'materialType',
				}, {
					title: '客户数量',
					dataIndex: 'unit',
				}, {
					title: '客户名称',
					dataIndex: 'subStoreId'
				}, {
					title: '期间',
					dataIndex: 'storeMax',
				}, {
					title: '累计购货额',
					dataIndex: 'storeMin',
				}, {
					title: '欠款额',
					dataIndex: 'boxCount',
				}, {
					title: '担保额',
					dataIndex: 'count',
				}
			],
			rows,
			rowSelection: {
				selectedRowKeys,
				onChange: this.onSelectChange
			}
		};
		return <div>
			<DmsTab options={opts} defaultKey={key} onChange={this.changeHandle}>
				{ button_limits_end.reportForm_accountStatement_01 && <Button onClick={this.goAdd.bind(this)}>导出</Button>}
			</DmsTab>
			<div className="dms-table-box">
				<AdvanceFormNew  {...filterBoxProps}/>
				<TableView {...tableViewProps}/>

				
			</div>
		</div>
	}
}
;
export default withRouter(AccountStatement);


// WEBPACK FOOTER //
// ./src/routes/reportForm/accountStatement.js